import React, { useState } from 'react';

import { MenuItem, Popover } from '@material-ui/core';
import Select from 'react-select';
import styled, { css } from 'styled-components';
import { VerticallyAlignedFlexContainer } from 'styles/common';

import { DotsIcon, EditPenIcon } from 'constants/icons';
import theme from 'constants/theme';

import CircularOutlineIcon from 'uiToolkit/CircularOutlineIcon';
import { Typography13 } from 'uiToolkit/Typography';

const StyledCircularOutlineIcon = styled(CircularOutlineIcon)`
  visibility: hidden;
  margin-left: 1.5rem;
`;
const StyledDotsIcon = styled(DotsIcon)`
  width: 13px;
  margin-top: 1px;
`;
const StyledMenuItem = styled(MenuItem)`
  padding-right: 30px;
  ${(props) =>
    props.$materialIcon &&
    css`
      svg {
        font-size: 1rem;
        width: 16px;
        height: 16px;
        color: ${(props) => props.theme.palette.icons.black.v1};
      }
    `}
`;
const EditTargetJobRole = ({ handleEditClick }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event) => {
    event.stopPropagation();
    setAnchorEl(null);
  };

  const onEditClick = (e) => {
    e.stopPropagation();

    handleEditClick();
  };

  return (
    <>
      <StyledCircularOutlineIcon onClick={handleClick} color="primary" icon={StyledDotsIcon} />
      <Popover
        disablePortal
        id="level-up-edit-role"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        style={{ marginTop: '0.5rem' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <StyledMenuItem onClick={handleEditClick}>
          <EditPenIcon size="fixed12px" color={theme.palette.icons.blackv1} />
          <Typography13 color={theme.palette.text.blackv1} leftGutter={2.25}>
            Edit
          </Typography13>
        </StyledMenuItem>
      </Popover>
    </>
  );
};

const JobRoleNameContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    ${StyledCircularOutlineIcon} {
      visibility: visible;
    }
  }
`;

export const Header = ({ selectOptions = [], selectedOption, setSelectedOption = () => {} }) => (
  <VerticallyAlignedFlexContainer style={{ width: '100%', padding: '1.5rem', justifyContent: 'space-between' }}>
    <Typography13 color={theme.palette.text.label}>Current View:</Typography13>
    <div style={{ width: '65%' }}>
      <Select
        options={selectOptions}
        value={selectedOption}
        isDisabled={selectOptions?.length < 2}
        onChange={(newValue) => setSelectedOption(newValue)}
      />
    </div>
  </VerticallyAlignedFlexContainer>
);
